import React, { Component } from "react";
import TagManager from 'react-gtm-module'
import { CoverSection, HomeTitle, FaqItem } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";
import { faqData } from "../../Data/Data";
import MenuHome from "../../Components/Menu/MenuHome";
import Footer from "../../Components/Footer/Footer";

class FAQ extends Component {
  state = {
    faq: faqData,
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find((o) => {
      return o.id === id;
    });
    if (current.isOpen === true) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq: faq,
    });
  };

  componentDidMount() {
    getWeather((Weather) => {
      // console.log('Weather', Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    const faqHtml = this.state.faq.map((o) => {
      return (
        <FaqItem
          q={o.q}
          answer={o.answer}
          isOpen={o.isOpen}
          click={() => {
            this.setCurrentFaq(o.id);
            TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'faq_click','element_location':'faq', 'click_cta':o.q,}});
          }}
        />
      );
    });
    return (
      <div className="page align-center page-FAQ inner-page">
        <MenuHome />
        <CoverSection
          desktopImg={"faq/cover/1.jpg"}
          mobileImg={"faq/cover/M.jpg"}
        />
        <div className="container">
          <HomeTitle>FAQ</HomeTitle>
          <div className="clear"></div>

          <div className="faq-wrapper">{faqHtml}</div>
          <div className="clear"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/Pages/FAQ/FAQ.js